<template>
	<db-row @mouseover="overHandler" @mouseleave="leaveHandler" class="auto-fill tabbar-item-wrapper" :class="'tabbar-route-' + chose" valign="middle" align="center" @click="clickHandler">
		<db-icon size="42" width="auto" :icon="nav.icon" class="tabbar-icon" v-if="nav.icon">
			<db-col width="12" height="12" class="dot" v-if="nav.dot" />
			<db-col width="auto" height="32" :class="['badge', read ? 'badge-undisplay' : 'badge-unread']" valign="middle" align="center" v-if="nav.badge && nav.badge != 0">{{nav.badge}}</db-col>
		</db-icon>
		<db-label size="inherit" color="inherit" class="tabbar-item-text">{{nav.label}}</db-label>
		
		<db-row height="auto" class="nav-combox-wrapper" v-if="nav.sub" v-show="show">
			<db-row height="auto" class="nav-combox-case">
				<db-col class="sub-nav-item" @click="subClick(nav)" valign="middle" align="center" height="88" v-for="(nav, idx) in nav.sub" :key="idx">{{nav.label}}</db-col>
			</db-row>
		</db-row>
	</db-row>
</template>

<script>
	export default {
		name: 'tabbar-item',
		
		props: {
			nav: {
				type: Object,
				default(){
					return {}
				}
			},
			
			value: {
				type: [String, Number, Boolean],
				default: ''
			}
		},
		
		data(){
			return {
				read: false,
				show: false
			}
		},
		
		computed: {
			chose(){
				if(this.nav.id){
					return this.nav.id == this.value
				}else{
					return this.$route.path === this.nav.path
				}
			}
		},
		
		mounted(){
			if(window.SUB_OBJECT){
				if(window.LOCKER === false){
					window.SUB_OBJECT.show = false
				}
			}else{
				document.body.onclick = () => {
					if(window.SUB_OBJECT){
						if(window.LOCKER === false){
							window.SUB_OBJECT.show = false
						}
					}
				}
			}
			window.SUB_OBJECT = this
		},
		
		methods: {
			overHandler(){
				window.LOCKER = true
			},
			
			leaveHandler(){
				window.LOCKER = false
			},
			
			clickHandler(){
				if(this.nav.sub && this.nav.sub.length > 0){
					this.show = !this.show
				}else{
					this.read = true
					this.nav.path && this.$router.push(this.nav.path)
					this.$emit('click')
					this.nav.handler && this.nav.handler()
				}
			},
			
			subClick({handler}){
				handler && handler()
				event.stopPropagation()
				this.show = false
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../assets/styles/vars.scss';
	
	.nav-combox-wrapper{
		position: absolute;
		bottom: 100%;
		margin-top: -8px;
		padding: 0 10px;
		
		.nav-combox-case{
			background: #f7f7f7;
			border-radius: 8px;
			box-shadow: 0 0 16px rgb(#000, .15);
			
			.sub-nav-item{
				font-size: 28px;
			}
		}
	}
	
	.tabbar-item-wrapper{
		font-size: inherit;
		color: inherit;
		position: relative;
		
		&.tabbar-route-true{
			color: #333;
		}
		&.tabbar-route-false{
			color: #666;
		}
		
		.tabbar-item-text{
			color: inherit;
		}
		
		.tabbar-icon{
			position: relative;
			margin-bottom: 16px;
			
			.dot{
				position: absolute;
				right: -8px;
				top: 0;
				background: $btn_danger_color;
				border-radius: 20px;
			}
			
			.badge{
				min-width: 32px;
				position: absolute;
				left: 100%;
				top: -6px;
				background: $btn_danger_color;
				border-radius: 100px;
				color: #fff;
				font-weight: bold;
				font-size: 22px;
				padding: 0 8px;
				margin-left: -18px;
				
				&.badge-unread{
					animation: badgeShake 2s infinite linear;
					animation-delay: 2s;
				}
				
				&.badge-undisplay{
					transition: transform .2s;
					transform: scale(0);
				}
			}
		}
	}
	
	@keyframes badgeShake{
		0%{
			transform: rotate(0);
		}
		3%{
			transform: rotate(-30deg);
		}
		9%{
			transform: rotate(30deg);
		}
		15%{
			transform: rotate(-30deg);
		}
		21%{
			transform: rotate(30deg);
		}
		27%{
			transform: rotate(-30deg);
		}
		33%{
			transform: rotate(30deg);
		}
		36%{
			transform: rotate(0);
		}
		100%{
			transform: rotate(0);
		}
	}
</style>
